import { CompanyImportPage } from "@/features/company/pages/CompanyImport";

const CompanyImport = () => {
  return (
    <CompanyImportPage />
  );
};

export default CompanyImport;
